import {Component, computed, inject, input} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {LucideAngularModule, MessageSquareLockIcon} from 'lucide-angular';
import {HostDTO} from '@domain/host/host.dto';

@Component({
  selector: 'app-host-contact-note',
  providers: [],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LucideAngularModule
  ],
  templateUrl: './host-contact-note.component.html'
})
export class HostContactNote {

  public readonly host = input.required<HostDTO>();
  private readonly hostMail = computed(() => this.host().email ?? '');
  private readonly hostName = computed(() => this.host().name ?? '');
  private readonly transloco = inject(TranslocoService);


  public readonly contactNote = computed(() => {
    const hostName = this.hostName();
    const hostMail = this.hostMail();
    return this.transloco.translate('activity.editor.contact.contact-note', {host: hostName, email: hostMail});
  });

  public readonly icons = {
    message: MessageSquareLockIcon
  };

}
